import {
  AlertCircleIcon,
  BuddiesIcon,
  LockIcon,
  ShareIcon,
  BlogIcon,
  UserIcon,
} from '../../components/ui/icons';
import type { PopoverMenuItem } from '../../components/ui/PopoverMenu';

export type ProfileMenuKey =
  | 'copyLink'
  | 'share'
  | 'toggleFollow'
  | 'report'
  | 'block'
  | 'removeBuddy';

interface ProfileMenuState {
  isBlocked: boolean;
  /** Adds "Remove Buddy"; ending a connection is never a primary action. */
  isBuddy?: boolean;
  /** Drives the follow entry's label; following is independent of buddying. */
  isFollowing?: boolean;
  /**
   * Restricted profiles omit the follow entry: following takes effect
   * immediately, so an inaccessible private profile must not offer it.
   */
  canFollow?: boolean;
}

export const buildProfileMenu = (
  { isBlocked, isBuddy = false, isFollowing = false, canFollow = true }: ProfileMenuState,
  t: (key: string, values?: Record<string, string | number>) => string,
): PopoverMenuItem<ProfileMenuKey>[] => [
  { key: 'copyLink', icon: BlogIcon, label: t('profile.menu.copyLink') },
  { key: 'share', icon: ShareIcon, label: t('profile.menu.share') },
  ...(canFollow
    ? [
        {
          key: 'toggleFollow' as const,
          icon: UserIcon,
          label: t(isFollowing ? 'profile.buttons.unfollow' : 'profile.buttons.follow'),
        },
      ]
    : []),
  ...(isBuddy
    ? [
        {
          key: 'removeBuddy' as const,
          icon: BuddiesIcon,
          label: t('profile.buttons.removeBuddy'),
          destructive: true,
        },
      ]
    : []),
  { key: 'report', icon: AlertCircleIcon, label: t('profile.menu.report') },
  {
    key: 'block',
    icon: LockIcon,
    label: t(isBlocked ? 'home.postOptions.unblockUser' : 'home.postOptions.blockUser'),
    destructive: !isBlocked,
  },
];
